import $ from 'jquery';

/**
 * Example

 <pre>
 //Change id to your id
 $("#ingredient_file").on("change", function (e) {
    var file = $(this)[0].files[0];
    var upload = new Upload(file);

    // maby check size or type here with upload.getSize() and upload.getType()

    // execute upload
    upload.doUpload();
});
 </pre>
 */
export default class FileUpload {
    constructor(file) {
        this.file = file;
        this.progressListener = null;
        this.xhr = null;
    }

    get type() {
        return this.file.type;
    }

    get size() {
        return this.file.size;
    }

    get name() {
        return this.file.name;
    }

    cancel() {
        if (this.xhr != null) {
            this.xhr.abort();
        }
    }

    doUpload(url) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();

            // add assoc key values, this will be posts values
            formData.append("file", this.file, this.name);
            formData.append("upload_file", "true");

            this.xhr = $.ajax({
                type: "POST",
                url: url,
                xhr: () => {
                    const myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                        myXhr.upload.addEventListener('progress', this.progressHandling.bind(this), false);
                    }
                    return myXhr;
                },
                success: function (data) {
                    resolve(data)
                },
                error: function (error) {
                    reject(error);
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false
            });
        });
    }

    progressHandling(event) {
        if (this.progressListener == null) {
            return;
        }
        let position = event.loaded || event.position;
        let total = event.total;
        this.progressListener(position, total);
    }
}

